/* eslint-disable indent */
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

import ReactHTMLTableToExcel from "react-html-table-to-excel";

import { loginTypeConstant } from "../../../constant/loginType/loginTypeConstant";
import TopInput from "./TopInput";
import {
  canteenActions,
  locationActions
} from "../../../redux/actions";
import CanteenUserList from "./CanteenUserList";
import { CanteenTypes } from "../../../redux/type/type";
import { helperFunction } from "../../../constant/helper";
import moment from "moment";
import {
  renderDate,
  totalCanteen
} from "../../../constant/helper/helper";
import Starter from "../../../component/Starter";
import isEmpty from "../../../validation/isEmpty";

const initialState = {
  Filter: "",
  toDate: "",
  fromDate: "",
  locationId: ""
};

const CanteenSheet = () => {
  const componentRef = useRef();

  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  const [dateDifference, setDateDifference] = useState(0);
  const [dateArrayState, setDateArrayState] = useState([]);
  const [sheetCanteenData, setSheetCanteenData] = useState([]);

  const { locations } = useSelector((state) => state.location);
  const { currentUser } = useSelector((state) => state.auth);
  const {
    toDate,
    fromDate,
    dataFormat,
    locationId,
    canteenError,
    canteenLoading,
    canteenSheetData
  } = useSelector((state) => state.canteen);

  useEffect(() => {
    if (!isEmpty(canteenSheetData)) {
      setSheetCanteenData(
        canteenSheetData.map((sheet) => {
          const dailyCanteen = [];
          const dailyPointsSheet = [];

          if (!isEmpty(sheet.canteenData)) {
            sheet.canteenData.map((dateValue) => {
              return dailyCanteen.push({
                Date: moment(dateValue.Date).format("DD/MM/yyyy"),
                breakFastTime: !isEmpty(dateValue.breakFastTime)
                  ? dateValue.breakFastTime
                  : "",
                lunchTime: !isEmpty(dateValue.lunchTime)
                  ? dateValue.lunchTime
                  : "",
                dinnerTime: !isEmpty(dateValue.dinnerTime)
                  ? dateValue.dinnerTime
                  : ""
              });
            });
          }

          const obj = _.mapKeys(dailyCanteen, "Date");
          dateArrayState.forEach((dateValue2) => {
            const breakFastTime = isEmpty(obj[dateValue2])
              ? null
              : obj[dateValue2].breakFastTime;
            const lunchTime = isEmpty(obj[dateValue2])
              ? null
              : obj[dateValue2].lunchTime;
            const dinnerTime = isEmpty(obj[dateValue2])
              ? null
              : obj[dateValue2].dinnerTime;

            return dailyPointsSheet.push({
              Date: dateValue2,
              breakFastTime,
              lunchTime,
              dinnerTime
            });
          });

          const {
            TotalBreakFast,
            TotalLunch,
            TotalDinner
          } = totalCanteen(dailyPointsSheet);

          return {
            TotalBreakFast,
            TotalLunch,
            TotalDinner,
            employeeId: sheet._id,
            workerId: sheet.workerId,
            Location: sheet.locationName,
            dailyPointsArray: dailyPointsSheet,
            workerDepartment: sheet.workerDepartment,
            workerDesignation: sheet.workerDesignation,
            workerFullName:
              sheet.workerFirstName + " " + sheet.workerSurname
          };
        })
      );
    }
  }, [canteenSheetData]);

  useEffect(() => {
    if (canteenError) {
      helperFunction.toastHelper("error", canteenError);
    }
  }, [canteenError]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    setValues({
      ...values,
      fromDate,
      toDate,
      locationId,
      dataFormat
    });
  }, [fromDate, toDate, locationId, dataFormat]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    // dispatch(locationActions.getAllLocation(loginType));
    return () => {
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
    };
  }, []);

  // fetch attendance
  const fetchCanteenSheet = (e) => {
    e.preventDefault();
    const { fromDate, toDate, locationId, dataFormat } = values;
    if (fromDate === "" || toDate === "") {
      const errorData = {
        data: {
          message: "From Date,To Date or Location is not selected"
        },
        status: 400
      };
      return dispatch({
        type: CanteenTypes.CANTEEN_GET_ERRORS,
        payload: errorData
      });
    } else {
      const diffTime = Math.abs(
        new Date(toDate) - new Date(fromDate)
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setDateDifference(diffDays);
      const dateArray = renderDate(values);
      const canteenType = "location";
      setDateArrayState(dateArray);
      dispatch(canteenActions.setCanteenLoading(true));
      dispatch(canteenActions.clearCanteenErrors());
      dispatch(canteenActions.clearCanteenResult());

      dispatch(
        canteenActions.getCanteenSheet(
          fromDate,
          toDate,
          locationId,
          loginType,
          canteenType,
          dataFormat
        )
      );
    }
  };

  return (
    <Starter
      topBarTitle="Canteen"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Canteen Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Canteen</a>
          </li>
          <li className="breadcrumb-item active">Canteen Sheet</li>
        </Fragment>
      }
    >
      <TopInput
        values={values}
        currentUser={currentUser}
        loading={canteenLoading}
        onChange={handleInputChange}
        onSubmit={fetchCanteenSheet}
        allLocations={
          typeof allLocations !== "undefined" &&
          allLocations.length > 0
            ? allLocations
            : []
        }
      />
      <CanteenUserList
        values={values}
        loginType={loginType}
        excelRef={componentRef}
        loading={canteenLoading}
        dateDifference={dateDifference}
        dateArrayState={dateArrayState}
        loginTypeConstant={loginTypeConstant}
        setDateArrayState={setDateArrayState}
        canteenSheetData={sheetCanteenData}
      />
      <div className="row mt-3">
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
        <div className="col-2">
          <ReactHTMLTableToExcel
            sheet="Sheet"
            buttonText="Export excel"
            table="products-datatable"
            className="btn btn-dark btn-block"
            filename={`${fromDate}_${toDate}`}
          />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
      </div>
    </Starter>
  );
};

export default CanteenSheet;
